export const translations = {
  en: {
    nav: {
      craft: "The Craft",
      heritage: "Heritage",
      gallery: "Works",
      commissions: "Commissions",
      contact: "Contact",
      cta: "Request a Quote",
    },
    hero: {
      overline: "Falegnameria Lomartire · Made in Italy Quality since 1958",
      titleLines: [
        "Furniture and fixtures",
        "you'll never replace.",
        "Built to last a hundred years.",
      ],
      subtitle:
        "Three generations of master craftsmen shaping solid wood into one-of-a-kind pieces. Made to measure, made in Italy: solid wood furniture and interior doors, exterior fixtures in laminated timber.",
      ctaPrimary: "Request Your Custom Piece",
      ctaSecondary: "Discover the Craft",
    },
    marquee: {
      items: [
        "Solid Wood",
        "Since 1958",
        "Made to Measure",
        "Puglia — Italy",
        "One-of-a-Kind Pieces",
        "Worldwide Delivery",
      ],
    },
    stats: {
      founded: "Founded in 1958",
      generations: "Generations of masters",
      made: "Made in Italy",
      delivery: "Worldwide delivery",
    },
    heritage: {
      overline: "Our Heritage",
      title: "A Family Legacy Carved in Wood",
      p1: "It all began in 1958, in a small family workshop in the heart of Puglia. A single mission: to build, from simple logs, masterpieces that could endure for entire generations.",
      p2: "Today, Giuseppe Lomartire — the latest craftsman of the Falegnameria Lomartire lineage — works oak, solid olive and other fine woods with the same passion as on day one, creating masterpieces.",
      quote: "Wood remembers every hand that touched it. We make sure it remembers ours.",
    },
    process: {
      overline: "How We Work",
      title: "From Your Idea to a Heirloom",
      chapter: "Chapter",
      steps: [
        {
          n: "01",
          title: "Listen & Design",
          text: "Tell us about your space and your vision. We sketch, measure and propose — every project starts with a conversation, not a catalogue.",
        },
        {
          n: "02",
          title: "Select & Shape",
          text: "Together we choose the right timber for your home: we quote the work and decide with you the model and finish that best reflect you. We then craft the project by hand, made to measure — no catalogues. Your piece will be one of a kind in the world.",
        },
        {
          n: "03",
          title: "Worldwide Delivery",
          text: "From our joinery to your home — anywhere in the world. Recent commissions have travelled as far as the United Arab Emirates.",
        },
      ],
      cta: "Start Your Project",
    },
    gallery: {
      overline: "Selected Works",
      title: "Pieces That Tell a Story",
      subtitle: "Home furnishing and fixtures for true connoisseurs who love the luxury of fine wood: for the few, forever.",
      items: {
        "dining-room": "Solid wood dining room",
        "sculpture": "Olive wood serving board",
        "door-arch": "Walnut entrance door",
        "door-arched-glass": "Interior door prepared for glass",
        "carving-detail": "Fine olive wood utensils",
        "table-desk": "Walnut living room side table",
        "drawers-inlay": "Walnut kitchen drawer unit",
        "kitchen-cabinet": "Hand-carved walnut mostrina panel",
        "door-interior": "Walnut landing door",
        "door-double-dining": "Sliding glass door — bespoke table and chairs beyond",
      },
      cta: "Commission Yours",
    },
    commissions: {
      overline: "Private Commissions",
      title: "Every Piece Is Unique: No Replicas.",
      text: "We accept a limited number of private commissions each year. Every piece is one of a kind and takes weeks of creation and personalization.",
      points: [
        "A dedicated master craftsman builds your project",
        "Worldwide delivery — every piece is carefully packed, insured and shipped straight to your door",
      ],
      cta: "Request a Private Commission",
      captions: [
        "Walnut living room side table",
        "Solid ash interior door, walnut-stained",
        "Sliding glass door — bespoke table and chairs beyond",
        "Detail — solid ash interior door, walnut-stained",
      ],
    },
    form: {
      overline: "Get in Touch",
      title: "Tell Us About Your Project",
      subtitle: "Share a few details and we will reply personally within 48 hours.",
      name: "Full name",
      namePh: "Your name",
      location: "Work location",
      locationPh: "City, country",
      phone: "Phone",
      phonePh: "+39 ...",
      type: "Project type",
      types: {
        interior_furnishing: "Interior furnishing",
        internal_fixtures: "Interior fixtures & doors",
        external_fixtures: "Exterior fixtures & doors",
        wooden_stairs: "Wooden staircases",
      },
      message: "Describe in detail the project you want to create",
      messagePh: "Describe your idea, dimensions, wood preferences, timeline...",
      submit: "Send Request",
      sending: "Sending...",
      successTitle: "Request received",
      successMsg: "Thank you — we will reply personally within 48 hours.",
      errorTitle: "Something went wrong",
      errorMsg: "Please try again or write to us on Instagram.",
    },
    footer: {
      tagline: "Bespoke furniture, handcrafted since 1958. Three generations of Italian excellence.",
      follow: "Follow the workshop",
      rights: "Falegnameria Lomartire. All rights reserved.",
    },
    floating: "Request a Quote",
  },
  it: {
    nav: {
      craft: "Il Mestiere",
      heritage: "La Storia",
      gallery: "I Lavori",
      commissions: "Su Commissione",
      contact: "Contatti",
      cta: "Richiedi un Preventivo",
    },
    hero: {
      overline: "Falegnameria Lomartire - Qualità Made in Italy dal 1958",
      titleLines: [
        "I mobili e gli infissi",
        "che non rifarai mai più.",
        "Fatti per durare cent'anni.",
      ],
      subtitle:
        "Tre generazioni di maestri falegnami che trasformano il legno massello in pezzi unici. Su misura, made in Italy: mobili e porte interne in massello, infissi esterni in legno lamellare.",
      ctaPrimary: "Richiedi il Tuo Pezzo Unico",
      ctaSecondary: "Scopri il Mestiere",
    },
    marquee: {
      items: [
        "Legno Massello",
        "Dal 1958",
        "Su Misura",
        "Puglia — Italia",
        "Pezzi Unici",
        "Consegna in Tutto il Mondo",
      ],
    },
    stats: {
      founded: "Fondata nel 1958",
      generations: "Generazioni di maestri",
      made: "Made in Italy",
      delivery: "Consegna in tutto il mondo",
    },
    heritage: {
      overline: "La Nostra Storia",
      title: "Una Tradizione di Famiglia Scolpita nel Legno",
      p1: "Tutto è iniziato nel 1958, in una piccola bottega di famiglia nel cuore della Puglia. Un'unica missione: costruire, da semplici tronchi, dei capolavori che potessero resistere per intere generazioni.",
      p2: "Oggi, Giuseppe Lomartire, ultimo artigiano della generazione di Falegnameria Lomartire, lavora rovere, ulivo massello ed altri legni pregiati con la stessa passione del primo giorno, creando capolavori.",
      quote: "Il legno ricorda ogni mano che lo ha toccato. Noi facciamo in modo che ricordi le nostre.",
    },
    process: {
      overline: "Come Lavoriamo",
      title: "Dalla Tua Idea a un'Eredità",
      chapter: "Capitolo",
      steps: [
        {
          n: "01",
          title: "Ascolto & Progetto",
          text: "Raccontaci il tuo spazio e la tua visione. Disegniamo, misuriamo e proponiamo — ogni progetto inizia con una conversazione, non con un catalogo.",
        },
        {
          n: "02",
          title: "Scelta & Lavorazione",
          text: "Scegliamo insieme il legname giusto per la tua casa: preventiviamo il lavoro e valutiamo insieme il modello e la verniciatura che più ti rispecchiano. Realizzeremo il progetto su misura, a mano: niente cataloghi. Il tuo lavoro sarà UNICO al mondo.",
        },
        {
          n: "03",
          title: "Consegna in Tutto il Mondo",
          text: "Dalla nostra falegnameria a casa tua — ovunque nel mondo. Le commissioni recenti sono arrivate fino agli Emirati Arabi Uniti.",
        },
      ],
      cta: "Inizia il Tuo Progetto",
    },
    gallery: {
      overline: "Lavori Selezionati",
      title: "Pezzi che Raccontano una Storia",
      subtitle: "Arredo casa ed infissi per veri intenditori che amano il lusso del legno pregiato: per pochi, per sempre.",
      items: {
        "dining-room": "Sala da pranzo in legno massello",
        "sculpture": "Tagliere realizzato in ulivo",
        "door-arch": "Portone di ingresso in noce",
        "door-arched-glass": "Porta interna con predisposizione vetro",
        "carving-detail": "Utensili in ulivo pregiati",
        "table-desk": "Tavolino da soggiorno in noce",
        "drawers-inlay": "Cassettiera per cucina in noce",
        "kitchen-cabinet": "Mostrina in noce realizzata e intagliata a mano",
        "door-interior": "Porta caposcala in noce",
        "door-double-dining": "Porta scorrevole a vetro — tavolo e sedie realizzati sullo sfondo",
      },
      cta: "Commissiona il Tuo",
    },
    commissions: {
      overline: "Commissioni Private",
      title: "Ogni pezzo è unico: nessuna replica.",
      text: "Accettiamo un numero limitato di commissioni private ogni anno. Ogni pezzo è unico e richiede settimane di creazione e personalizzazione.",
      points: [
        "Maestro falegname addetto alla realizzazione del progetto",
        "Consegna in tutto il mondo — ogni pezzo è imballato con cura, assicurato e spedito direttamente a casa tua",
      ],
      cta: "Richiedi una Commissione Privata",
      captions: [
        "Tavolino da soggiorno in noce",
        "Porta interna in frassino massello tinta noce",
        "Porta scorrevole a vetro — tavolo e sedie realizzati sullo sfondo",
        "Dettaglio porta interna in frassino massello tinta noce",
      ],
    },
    form: {
      overline: "Contattaci",
      title: "Raccontaci il Tuo Progetto",
      subtitle: "Condividi qualche dettaglio: ti risponderemo personalmente entro 48 ore.",
      name: "Nome e cognome",
      namePh: "Il tuo nome",
      location: "Luogo del lavoro",
      locationPh: "Città, provincia",
      phone: "Telefono",
      phonePh: "+39 ...",
      type: "Tipo di progetto",
      types: {
        interior_furnishing: "Arredo interni",
        internal_fixtures: "Infissi interni",
        external_fixtures: "Infissi esterni",
        wooden_stairs: "Scalinate in legno",
      },
      message: "Descrivi nel dettaglio il progetto che vuoi realizzare",
      messagePh: "Descrivi la tua idea, misure, essenze preferite, tempi...",
      submit: "Invia Richiesta",
      sending: "Invio in corso...",
      successTitle: "Richiesta ricevuta",
      successMsg: "Grazie — ti risponderemo personalmente entro 48 ore.",
      errorTitle: "Qualcosa è andato storto",
      errorMsg: "Riprova o scrivici su Instagram.",
    },
    footer: {
      tagline: "Mobili su misura, fatti a mano dal 1958. Tre generazioni di eccellenza italiana.",
      follow: "Segui il laboratorio",
      rights: "Falegnameria Lomartire. Tutti i diritti riservati.",
    },
    floating: "Richiedi un Preventivo",
  },
};
